module.exports = __webpack_public_path__ + "img/perfect_money_select.421842d6.png";